import React, { Component, ReactNode } from 'react';
import * as Sentry from '@sentry/react';

interface State {
  hasError: boolean;
}
interface Props {
  Component?: any;
  children: ReactNode;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error) {
    Sentry.captureException(error);
  }

  render() {
    const { Component, children } = this.props;
    if (!!Component && this.state.hasError) {
      return <Component />;
    }

    return children;
  }
}

export default ErrorBoundary;
